<template>
    <div>       
        <npi-search-modal></npi-search-modal>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="provider_npi">Provider <small class="text-muted"><em>(Required)</em></small></label>
                <div class="input-group">
                    <select id="provider_npi" v-bind:class="['custom-select', {'is-invalid' : hasError('provider_npi') }]" name="provider_npi" @change="onChange" v-model="selectedNPI" :disabled="readonly">
                        <option v-for="option in options" :key="option.npi" :value="option.npi" v-text="option.name"></option>
                    </select>
                    <input id="provider_name" type="hidden" name="provider_name" v-model="provider.name">       
                    <div class="input-group-append" data-toggle="tooltip" title="Search NPI Registry">
                        <button type="button" class="btn btn-primary btn-sm" @click="onSearch" :disabled="readonly"><i class="fas fa-search fa-lg"></i></button>
                    </div>                    
                </div>
                <span v-if="hasError('provider_npi')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_npi')"></strong>
                </span>            
            </div>
            <div v-if="facilities && facilities.length > 1" class="form-group col-md-4">
                <label for="provider_facility">Facility</label>
                <select id="provider_facility" v-bind:class="['custom-select', { 'text-muted' : this == 'Default' }]" @change="onChangeFacility" v-model="selectedFacility" :disabled="readonly">
                    <option v-for="facility in facilities" :key="facility.id" :value="facility" v-text="facility.name"></option>
                </select>
            </div>
        </div>
        <hr />
        <div class="row mt-4">
            <div class="form-group col-md-6">
                <label for="requesting_provider_name">Requesting Health Care Provider <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="requesting_provider_name" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('requesting_provider_name') }]" name="requesting_provider_name" v-model="provider.requesting_provider_name" :disabled="readonly">
                <span v-if="hasError('requesting_provider_name')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('requesting_provider_name')"></strong>
                </span>                 
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-3">
                <label for="provider_contact">Contact <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_contact" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_contact') }]" name="provider_contact" v-model="provider.contact" :disabled="readonly">
                <span v-if="hasError('provider_contact')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_contact')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-3">
                <label for="provider_email">Email <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_email" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_email') }]" name="provider_email" v-model="provider.email" :disabled="readonly">
                <span v-if="hasError('provider_email')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_email')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-3">
                <label for="provider_phone">Phone Number <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="provider_phone" v-bind:class="['form-control', {'is-invalid' : hasError('provider_phone') }]" name="provider_phone" v-model="provider.phone" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-phone pt-2"></span>
                    </div>
                    <span v-if="hasError('provider_phone')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('provider_phone')"></strong>
                    </span>                                  
                </div>
            </div>
            <div class="form-group col-md-3">
                <label for="provider_fax">Worx Fax Number <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="provider_fax" v-bind:class="['form-control', {'is-invalid' : hasError('provider_fax') }]" name="provider_fax" v-model="provider.fax" readonly></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-fax pt-2"></span>
                    </div> 
                    <span v-if="hasError('provider_fax')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('provider_fax')"></strong>
                    </span>                                 
                </div>
            </div>            
        </div>
        <div class="row">
            <div class="form-group col-md-5">
                <label for="provider_address">Address <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_address" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_address') }]" name="provider_address" v-model="provider.address" :disabled="readonly">
                <span v-if="hasError('provider_address')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_address')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-3">
                <label for="provider_city">City <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_city" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_city') }]" name="provider_city" v-model="provider.city" :disabled="readonly">
                <span v-if="hasError('provider_city')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_city')"></strong>
                </span>                
            </div>
            <div class="form-group col-md-2">
                <label for="provider_state">State <small class="text-muted"><em>(Optional)</em></small></label>
                <select id="provider_state" v-bind:class="['custom-select', {'is-invalid' : hasError('provider_state') }]" name="provider_state" v-model="provider.state" :disabled="readonly">
                    <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
                </select>
                <span v-if="hasError('provider_state')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_state')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-2">
                <label for="provider_postal_code">Postal Code <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_postal_code" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_postal_code') }]" name="provider_postal_code" v-model="provider.postal_code" :disabled="readonly">
                <span v-if="hasError('provider_postal_code')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_postal_code')"></strong>
                </span>                 
            </div>             
        </div>
    </div>
</template>

<script>
export default {
    props: {
        providers: Array,
        model: Object,
        errors: Object,
        readonly: Boolean,
        states: Array,
        clientId: Number
    },
    data() {
        return {
            selectedNPI: this.model.npi,
            provider: this.model,
            options: this.providers,
            facilities: [],
            selectedFacility: 'Default',
            alternateName: false
        }
    },
    methods: {
        hasError: function (name) {
            return this.errors.hasOwnProperty(name);
        },
        errorText: function (name) {
            return this.errors[name][0];
        },
        update: function(npi) {
            let selected = this.options.find(function(element) {
                return element.npi == npi;
            });

            if (selected) {
                this.provider.npi = selected.npi;
                this.provider.name = selected.name;
                this.provider.requesting_provider_name = selected.requesting_provider_name;
                this.provider.address = selected.address;
                this.provider.city = selected.city;
                this.provider.state = selected.state;
                this.provider.postal_code = selected.postal_code;
                this.provider.phone = selected.phone;
                this.provider.fax = selected.fax;

                this.selectedFacility = 'Default';
                this.facilities = this.getFacilities(selected.npi);
            }
            else {
                this.provider.npi = '';
                this.provider.name = '';
                this.provider.requesting_provider_name = '';
                this.provider.address = '';
                this.provider.city = '';
                this.provider.state = '';
                this.provider.postal_code = '';
                this.provider.phone = '';
                this.provider.fax = ''; 
                
                this.selectedFacility = 'Default';
                this.facilities = [];
            }
        },
        onChange: function (e) {
            this.update(e.target.value);
        },
        onSearch: function () {
            eventHub.$emit('show-npi-search', this.clientId);
        },
        refreshProviders: function(npi) {
            var self = this;
            axios.get('/ajax/clients/' + self.clientId + '/npi/options')
                .then(response => {
                    self.options = response.data.options;

                    // set selected option if passed in
                    if (npi) {
                        self.selectedNPI = npi;
                        self.update(npi);   
                    }
                })
                .catch(error => {
                    // TODO: handle error with toastr
                });
        },
        getFacilities: function (npi) {
            axios.get('/ajax/providers/' + npi + '/facilities')
                .then(response => {

                    this.facilities = response.data;

                    var address = this.provider.address;
                    this.selectedFacility = this.facilities.find(function (facility) {
                        return facility.address == address;
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        onChangeFacility: function () {
            this.provider.address = this.selectedFacility.address;
            this.provider.city = this.selectedFacility.city;
            this.provider.state = this.selectedFacility.state;
            this.provider.postal_code = this.selectedFacility.postal_code;
            this.provider.phone = this.selectedFacility.phone_number;
        }
    },
    created() {

        // if no provider has been selected and there is only one provider pre-select it
        if (!this.selectedNPI && this.providers.length == 1) {
            this.selectedNPI = this.providers[0].npi;
            this.update(this.selectedNPI);
        }

        if (this.selectedNPI) {
            this.facilities = this.getFacilities(this.selectedNPI);
        }

        eventHub.$on('refresh-providers', this.refreshProviders);
    },
    beforeDestroy() {
        eventHub.$off('refresh-providers');
    },
    watch: {
        providers: function (value) {
            this.options = value;
        },
        clientId: function (value) {
            this.selectedNPI = null;
            this.update();
        },
    },     
}
</script>

<style>

    .v-select  {
        background-color: #fff;
    }

    .v-select input[type=search], .v-select input[type=search]:focus {
        flex-basis: 20px;
        flex-grow: 1;
        height: 27px;
        padding: 0 20px 0 10px;
        width: 100% !important;
    }

    .d-center {
        display: flex;
        align-items: center;
    }

    /* .v-select .dropdown li {
        border-bottom: 1px solid rgba(112, 128, 144, 0.1);
    }

    .v-select .dropdown li:last-child {
        border-bottom: none;
    }

    .v-select .dropdown li a {
        padding: 10px 20px;
        width: 100%;
        font-size: 1.25em;
        color: #3c3c3c;
    }

    .v-select .dropdown-menu .active > a {
        color: #fff;
    } */

</style>


